

import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    HStack,
    Spacer,
    Box,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { CreateSRA, CreateUser, GetAllStores, GetAllSuppliers, GetAllUserType, UpdateSRAAPI } from '../Utils/ApiCalls';
import { AiOutlineFieldNumber, AiTwotoneMail } from 'react-icons/ai';
import ProductCard from './ProductCard';
import MsgCallback from './MsgCallback';
import { TbFileInvoice } from 'react-icons/tb';
import { BsCalendar2Date, BsFilePostFill } from 'react-icons/bs';
import { BiUser, BiUserPin } from 'react-icons/bi';
import jwtDecode from 'jwt-decode';
import { isEmergency } from '../Authetication';



export default function CreateSRAModal({ isOpen, onClose, actionType, singleItem }) {

    const [UserType, setUserType] = useState([]);
    const [SupplierData, setSupplierData] = useState([]);


    const [Data, setData] = useState([]);

    let ImsToken = JSON.parse(localStorage.getItem("ImsToken"))

    let onlineUser = jwtDecode(ImsToken)

    const [Payload, setPayload] = useState({

        sranumber: "",
        product: [
            {
                shelfid: "",
                qtyinspected: "",
                price: ""
            },


        ],
        suppliersname: "",
        invoicenumber: "",
        itemnos: "",
        costcenter: "",
        raised: onlineUser.unique_name,
        received: "",
        postedonstockcard: "",
        inwardsfreight: "",
        customduty: "",
        datereceived: ""

    });

    const [UpdatedPayload, setUpdatedPayload] = useState({

        sranumber: "",
        product: [
            {
                shelfid: "",
                qtyinspected: "",
                price: ""
            },


        ],
        suppliersname: "",
        invoicenumber: "",
        itemnos: "",
        costcenter: "",
        raised: onlineUser.unique_name,
        received: "",
        postedonstockcard: "",
        inwardsfreight: "",
        customduty: "",
        datereceived: ""
    });

    console.log("payload on change", UpdatedPayload);


    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });

    // const getUserType = async () => {

    //     let result = await GetAllUserType()

    //     if (result.status == true) {
    //         setUserType(result.queryresult)

    //     }
    // }
    const [Loading, setLoading] = useState(false);

    const [Emergency, setEmergency] = useState(isEmergency());


    const handleSRA = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })

    }
    const handleUpdatedSRA = (e) => {
        setUpdatedPayload({ ...UpdatedPayload, [e.target.id]: e.target.value })

    }


    const CreateNewSRA = async () => {

        try {
            setLoading(true)
            let result = await CreateSRA(Payload);
            console.log("result sra", result);
            if (result.status == true) {
                setLoading(false)
                setErrorMsg({
                    status: false,

                })

                setSuccessMsg({
                    status: true,
                    msg: "SRA created successfully"
                })

                setPayload({

                    sranumber: "",
                    product: [
                        {
                            shelfid: "",
                            qtyinspected: "",
                            price: ""
                        },

                    ],
                    suppliersname: "",
                    invoicenumber: "",
                    itemnos: "",
                    costcenter: "",
                    raised: onlineUser.unique_name,
                    received: "",
                    postedonstockcard: "",
                    inwardsfreight: "",
                    customduty: "",
                    store: "",
                    datereceived: ""

                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()
                }, 3000);

            } else {
                setLoading(false)

                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
    const UpdateSRA = async () => {

        try {
            setLoading(true)
            let result = await UpdateSRAAPI(UpdatedPayload, singleItem[0]._id);
            console.log("UpdateSRA_Result ", result);
            if (result.status == true) {
                setLoading(false)
                setErrorMsg({
                    status: false,

                })

                setSuccessMsg({
                    status: true,
                    msg: "SRA Updated successfully"
                })

               

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        
                    })
                    onClose()
                }, 3000);

            } else {
                setLoading(false)

                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }

    const AllStores = async () => {
        let result = await GetAllStores()

        if (result.status === true) {
            setData(result.queryresult)
        }
    }


    const GetSuppliers = async () => {
        let result = await GetAllSuppliers()

        console.log("dsds", result)



        if (result.status == true) {
            setSupplierData(result.queryresult)
        }
    }


    console.log("singleItem", singleItem)
    
    useEffect(() => {
        GetSuppliers()
        AllStores();
        
        
        setUpdatedPayload({
            sranumber: singleItem[0]?.sranumber,

            product: [
                {
                    shelfid: "",
                    qtyinspected: "",
                    price: ""
                },
                
                
            ],
            suppliersname: singleItem[0]?.suppliersname,
            invoicenumber: singleItem[0]?.invoicenumber,
            itemnos: singleItem[0]?.itemnos,
            costcenter: singleItem[0]?.costcenter,
            raised: onlineUser.unique_name,
            received: singleItem[0]?.received,
            postedonstockcard: singleItem[0]?.postedonstockcard,
            inwardsfreight: singleItem[0]?.inwardsfreight,
            customduty: singleItem[0]?.customduty,
            datereceived: singleItem[0]?.datereceived
        })
        



    }, [isOpen,actionType]);

    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{actionType === "create" ? "Create SRA" : "Edit SRA"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    {
                        actionType === "create" ? (
                            <Box>
                                <Stack spacing={"15px"}>

                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<BiUser />} iconColor="black" labelBg='#fff' label='Suppliers Name' id="suppliersname" type='text' value={Payload.suppliersname} val={Payload.suppliersname != "" ? true : false} onChange={handleSRA} />

                                        {
                                            Emergency && (

                                                <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Store' fontWeight={"400"} fontSize={Payload.store != "" ? "16px" : "12px"} id='store' value={Payload.store} onChange={handleSRA} >
                                                    {
                                                        Data?.filter(item => item.value != 1).map((item, i) => (

                                                            <option value={`${item.value}`}>{item.name}</option>
                                                        ))
                                                    }

                                                </Select>
                                            )
                                        }
                                    </HStack>

                                    <Stack spacing={"10px"}>
                                        <HStack>
                                            <Text>Product</Text>
                                            <Spacer />
                                            <Text cursor={"pointer"} onClick={() => setPayload(

                                                {
                                                    ...Payload,
                                                    product: [...Payload.product, {
                                                        shelfid: "",
                                                        qtyinspected: "",
                                                        vocab: "",
                                                    },]
                                                }
                                            )}>Add more <span>+</span></Text>
                                        </HStack>

                                        {
                                            Payload.product.map((item, i) => (

                                                <ProductCard data={item} oldItem={Payload.product} Payload={Payload} setPayload={setPayload} key={i} i={i} />
                                            ))
                                        }

                                    </Stack>



                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<TbFileInvoice />} iconColor="black" labelBg='#fff' label='Invoice Number' id="invoicenumber" type='number' value={Payload.invoicenumber} val={Payload.invoicenumber != "" ? true : false} onChange={handleSRA} />
                                        <Input leftIcon={<TbFileInvoice />} iconColor="black" labelBg='#fff' label='IIR number' id="itemnos" type='number' value={Payload.itemnos} val={Payload.itemnos != "" ? true : false} onChange={handleSRA} />

                                    </HStack>
                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Cost Center' id="costcenter" type='text' value={Payload.costcenter} val={Payload.costcenter != "" ? true : false} onChange={handleSRA} />
                                        <Input leftIcon={<BiUserPin />} iconColor="black" labelBg='#fff' label='Raised by' id="raised" type='text' value={onlineUser.unique_name} val={Payload.raised != "" ? true : false} onChange={handleSRA} />

                                    </HStack>
                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<BiUserPin />} iconColor="black" labelBg='#fff' label='Received by' id="received" type='text' value={Payload.received} val={Payload.received != "" ? true : false} onChange={handleSRA} />
                                        <Input leftIcon={<BsCalendar2Date />} iconColor="black" labelBg='#fff' id="datereceived" type='date' value={Payload.datereceived} val={Payload.datereceived != "" ? true : false} onChange={handleSRA} />


                                    </HStack>

                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='inwards Freight' id="inwardsfreight" type='number' value={Payload.inwardsfreight} val={Payload.inwardsfreight != "" ? true : false} onChange={handleSRA} />
                                        <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Custom Duty' id="customduty" type='number' value={Payload.customduty} val={Payload.customduty != "" ? true : false} onChange={handleSRA} />

                                    </HStack>

                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<BsFilePostFill />} iconColor="black" labelBg='#fff' label='Posted on Stock Card' id="postedonstockcard" type='text' value={Payload.postedonstockcard} val={Payload.postedonstockcard != "" ? true : false} onChange={handleSRA} />

                                    </HStack>




                                </Stack>

                                <Button mt="14px" isLoading={Loading}
                                    disabled={Payload.firstname != "" && Payload.lastname != "" && Payload.email != "" && Payload.store != "" && Payload.staffid != "" && Payload.usertype != "" ? false : true}
                                    onClick={CreateNewSRA}>Create new SRA</Button>
                            </Box>
                        ) : (
                            <Box>
                                <Stack spacing={"15px"}>

                                    {/* FORM FOR EDITING  */}

                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<BiUser />} iconColor="black" labelBg='#fff' label='Suppliers Name' id="suppliersname" type='text' value={UpdatedPayload.suppliersname} val={UpdatedPayload.suppliersname != "" ? true : false} onChange={handleUpdatedSRA} />

                                        {
                                            Emergency && (

                                                <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Store' fontWeight={"400"} fontSize={UpdatedPayload.store != "" ? "16px" : "12px"} id='store' value={UpdatedPayload.store} onChange={handleUpdatedSRA} >
                                                    {
                                                        Data?.filter(item => item.value != 1).map((item, i) => (

                                                            <option value={`${item.value}`}>{item.name}</option>
                                                        ))
                                                    }

                                                </Select>
                                            )
                                        }
                                    </HStack>

                                    <Stack spacing={"10px"}>
                                        <HStack>
                                            <Text>Product</Text>
                                            <Spacer />
                                            <Text cursor={"pointer"} onClick={() => setUpdatedPayload(

                                                {
                                                    ...UpdatedPayload,
                                                    product: [...UpdatedPayload.product, {
                                                        shelfid: "",
                                                        qtyinspected: "",
                                                        vocab: "",
                                                    },]
                                                }
                                            )}>Add more <span>+</span></Text>
                                        </HStack>

                                        {
                                            UpdatedPayload.product.map((item, i) => (

                                                <ProductCard data={item} oldItem={UpdatedPayload.product} Payload={UpdatedPayload} setPayload={setUpdatedPayload} key={i} i={i} />
                                            ))
                                        }

                                    </Stack>



                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<TbFileInvoice />} iconColor="black" labelBg='#fff' label='Invoice Number' id="invoicenumber" type='number' value={UpdatedPayload.invoicenumber} val={UpdatedPayload.invoicenumber != "" ? true : false} onChange={handleUpdatedSRA} />
                                        <Input leftIcon={<TbFileInvoice />} iconColor="black" labelBg='#fff' label='IIR number' id="itemnos" type='number' value={UpdatedPayload.itemnos} val={UpdatedPayload.itemnos != "" ? true : false} onChange={handleUpdatedSRA} />

                                    </HStack>
                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Cost Center' id="costcenter" type='text' value={UpdatedPayload.costcenter} val={UpdatedPayload.costcenter != "" ? true : false} onChange={handleUpdatedSRA} />
                                        <Input leftIcon={<BiUserPin />} iconColor="black" labelBg='#fff' label='Raised by' id="raised" type='text' value={onlineUser.unique_name} val={UpdatedPayload.raised != "" ? true : false} onChange={handleUpdatedSRA} />

                                    </HStack>
                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<BiUserPin />} iconColor="black" labelBg='#fff' label='Received by' id="received" type='text' value={UpdatedPayload.received} val={UpdatedPayload.received != "" ? true : false} onChange={handleUpdatedSRA} />
                                        <Input leftIcon={<BsCalendar2Date />} iconColor="black" labelBg='#fff' id="datereceived" type='date' value={UpdatedPayload.datereceived} val={UpdatedPayload.datereceived != "" ? true : false} onChange={handleUpdatedSRA} />


                                    </HStack>

                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='inwards Freight' id="inwardsfreight" type='number' value={UpdatedPayload.inwardsfreight} val={UpdatedPayload.inwardsfreight != "" ? true : false} onChange={handleUpdatedSRA} />
                                        <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Custom Duty' id="customduty" type='number' value={UpdatedPayload.customduty} val={UpdatedPayload.customduty != "" ? true : false} onChange={handleUpdatedSRA} />

                                    </HStack>

                                    <HStack spacing={"10px"}>
                                        <Input leftIcon={<BsFilePostFill />} iconColor="black" labelBg='#fff' label='Posted on Stock Card' id="postedonstockcard" type='text' value={UpdatedPayload.postedonstockcard} val={UpdatedPayload.postedonstockcard != "" ? true : false} onChange={handleUpdatedSRA} />

                                    </HStack>




                                </Stack>

                                <Button mt="14px" isLoading={Loading}
                                    disabled={UpdatedPayload.firstname != "" && UpdatedPayload.lastname != "" && UpdatedPayload.email != "" && UpdatedPayload.store != "" && UpdatedPayload.staffid != "" && UpdatedPayload.usertype != "" ? false : true}
                                    onClick={UpdateSRA}>Update SRA</Button>
                            </Box>
                        )
                    }



                    <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
